
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ShuffleMaps/EventsCalendar",
      function () {
        return require("private-next-pages/ShuffleMaps/EventsCalendar.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ShuffleMaps/EventsCalendar"])
      });
    }
  